import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { fromMoment, toMomentUTC } from 'foundations-components/transitional/utils/SimpleDate';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldDate = ({
  disabled,
  formField,
  onChange,
  value = null
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const {
    label,
    required
  } = formField;
  const isError = formField.required && (showAllErrors || hasBeenBlurred) && !value;
  const errorKey = `empty${label}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: label
      }
    }));
  }, [isError, dispatch, label, errorKey]);
  const momentValue = I18n.moment.utc(value);
  const sanitizedValue = !value || isNaN(momentValue.valueOf()) ? undefined : fromMoment(momentValue);
  const handleOnChange = event => {
    const utcDatetime = toMomentUTC(event.target.value).valueOf() || null;
    onChange(syntheticEvent(utcDatetime));
  };
  const placeholder = I18n.moment.localeData().longDateFormat('L') || 'MM/DD/YYYY';
  return /*#__PURE__*/_jsx(FormControl, {
    paddingBlockStart: "500",
    help: formField.description,
    label: label,
    required: required,
    error: isError,
    validationMessage: isError && errorMessage,
    children: /*#__PURE__*/_jsx(DateInput, {
      "data-test-id": "custom-form-field-date-input",
      disabled: disabled,
      onChange: handleOnChange,
      placeholder: placeholder,
      use: "on-dark",
      value: sanitizedValue,
      onFocusedValueChange: () => setHasBeenBlurred(true)
    })
  });
};
export default CustomFormFieldDate;